import Analytics from '../analytics';
import { getLogger } from '../logging/logger';

const logger = getLogger('FontLoader');

export default class FontLoader {
	static preloadDocumentFonts() {
		logger.log('[preloadDocumentFonts]');

		const fonts = Array.from(document.fonts.values());
		return Promise.all(fonts.map((font) => font.load())).catch((error) => {
			logger.error('[Error preloading fonts]', error);
			Analytics.sendEvent('FontLoader-Error', {
				error: JSON.stringify(error),
			});
		});
	}
}
